import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { useRequest } from "../../hooks/useRequest";
import { BoxWeather } from "./BoxWeather";
import { getApiUrl } from '../../app-config';
import { HotelDataInterface } from "../../core/interfaces/HotelDataInterface";

export const WeatherVisualizerComponent = ({ uiData }) => {

    const appData: HotelDataInterface = useSelector((state: any) => state.app);



    const [boxState, setBoxState] = useState(false);
    const { data, loading } = useRequest(getApiUrl('Weather/' + appData.destination));

    const [bgcolor, setBgColor] = useState(null);
    const [textColor, setTextColor] = useState(null);


    const handleToggleBox = () => {
        setBoxState(!boxState);
    }

    useEffect(() => {
        if (data) {
            const current = new Date().getHours()+1;
            //console.log(uiData, current);
            const stateTime = uiData.weather.reverse().find(item => current >= +item.hourFrom) || uiData.weather[0];
            setBgColor(stateTime?.backgroundColor);
            setTextColor(stateTime?.textColor);
        }
        // eslint-disable-next-line
    }, [data]);


    return (
        <div className="p-2">

            {!loading ? (<>
                <div className="flex flex-row items-center">
                    <img src={data?.current?.condition?.icon} alt="" width={'26px'} height={'26px'} />

                    <span className="ml-2 location_text">
                        {data?.location?.name}, {data.location?.region}
                    </span>
                </div>

                <div>
                    <span className="temperature_text">{data?.current?.temp_c} °C</span>
                    <span className="link ml-2 text-sky-500 hover:text-cyan-700 cursor-pointer" onClick={handleToggleBox}>Ver detalle</span>
                </div>

                {boxState && <BoxWeather data={data} background={bgcolor} textcolor={textColor} />}
            </>) : (
                <>
                    Loading...
                </>

            )}

        </div>
    )
}
